import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {withAnswer} from '#components/HOC/withAnswerHOC'
import Checkbox from '#components/a/form/Checkbox'
import QuestionDescription from './QuestionDescription'

export class QuestionMultipleChoice extends React.Component {
  defaultAnswer = {
    selectedIndices: [],
  }

  isSelected = (answer, index) => answer && answer.selectedIndices && answer.selectedIndices.indexOf(index) >= 0

  removeItem = (array, itemToRemove) => array.filter(i => i !== itemToRemove)

  onToggleCheckbox = index => {
    const {currentAnswer} = this.props
    let newSelection
    if (!currentAnswer || !currentAnswer.selectedIndices) {
      newSelection = [index]
    } else if (this.isSelected(currentAnswer, index)) {
      newSelection = this.removeItem(currentAnswer.selectedIndices, index)
    } else {
      newSelection = [...currentAnswer.selectedIndices, index]
    }
    this.props.saveAnswer({selectedIndices: newSelection})
  }

  getCurrentAnswer = () => {
    const {currentAnswer} = this.props
    return currentAnswer && currentAnswer.selectedIndices ? currentAnswer : this.defaultAnswer
  }

  render() {
    const {question, isReadOnly} = this.props
    const answer = this.getCurrentAnswer()
    return (
      <>
        {this.props.children}
        <QuestionDescription question={question} />
        {question.content.map(a => (
          <Checkbox
            disabledState={isReadOnly}
            size="large"
            key={a.order}
            checked={this.isSelected(answer, a.order)}
            onChangeHandle={() => this.onToggleCheckbox(a.order)}
            labelText={a.text}
          />
        ))}
      </>
    )
  }
}

QuestionMultipleChoice.propTypes = {
  saveAnswer: PropTypes.func.isRequired,
  question: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  currentAnswer: PropTypes.object,
  children: PropTypes.node,
}

export default withAnswer(QuestionMultipleChoice)
